import React from 'react';
import { Navbar, Nav, Container } from 'react-bootstrap';
import { TrendingUp, Briefcase, Users } from 'lucide-react';
import { LinkContainer } from 'react-router-bootstrap';

const Navigation = () => {
  return (
    <Navbar bg="primary" variant="dark" expand="lg">
      <Container>
        <Navbar.Brand href="/" className="d-flex align-items-center">
          <TrendingUp className="me-2" size={24} />
          EH Immigration Analytics
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <LinkContainer to="/">
              <Nav.Link>
                <TrendingUp className="me-1" size={16} />
                Search Trends
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/jobs">
              <Nav.Link>
                <Briefcase className="me-1" size={16} />
                Job Analytics
              </Nav.Link>
            </LinkContainer>
            <LinkContainer to="/zoho-leads">
              <Nav.Link>
                <Users className="me-1" size={16} />
                Zoho Leads
              </Nav.Link>
            </LinkContainer>
          </Nav>
          <Navbar.Text>Real-time market insights</Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navigation;
